<template>
    <div class="wrapper">
        <side-bar>
            <template slot="links">
                <!-- <sidebar-link to="/dashboard" name="Dashboard" icon="ti-panel"/> -->
                <!-- <sidebar-link to="/researches" name="Researches" icon="ti-menu-alt"/>
        <sidebar-link to="#" name="Rankings" icon="ti-bar-chart-alt"/> -->
                <sidebar-link v-if="allowedForDashboard || büro || temp || qs || kh || ekki" to="/qs" name="Qualitätssicherung" icon="ti-agenda" />
                <div class="sidebar-trenner">
                    <div v-if="allowedForDashboard || büro || fahrer || kh" class="logo" id="logotrenner">
                        <a v-if="allowedForDashboard || büro || fahrer || kh" href="#" class="simple-text">
                            <div class="logoimg">
                                <img src="@/assets/img/logo_heimspiel.png" alt="" />
                            </div>
                            heimspiel!
                        </a>
                    </div>
                </div>
                <sidebar-link v-if="allowedForDashboard" to="/umsätze" name="Umsätze" icon="ti-bar-chart-alt" />
                <sidebar-link v-if="allowedForDashboard || büro" to="/kunden" name="Kunden" icon="ti-user" />
                <sidebar-link v-if="allowedForDashboard || büro || fahrer" to="/tagestour" name="Tagestour" icon="ti-car" />
                <sidebar-link v-if="allowedForDashboard || büro || fahrer" to="/kalender" name="Kalender" icon="ti-calendar" />
                <sidebar-link v-if="allowedForDashboard || büro || fahrer || kh" to="/checklists/driver" name="Checkliste" icon="ti-check-box" />
                <sidebar-link v-if="allowedForDashboard || büro || fahrer" to="/informationen" name="Informationen" icon="ti-info-alt" />

                <!-- <sidebar-link to="/suggests" name="Suggests" icon="ti-text"/>
        <sidebar-link to="/upload" name="Upload" icon="ti-upload"/> -->

                <!-- <sidebar-link to="/typography" name="Typography" icon="ti-text"/>
        <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2"/>
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell"/> -->
            </template>

            <mobile-menu>
                <sidebar-link v-if="!isLoggedIn" to="/login" name="Login" icon="ti-user" />
                <li v-if="isLoggedIn" class="nav-item"><button v-on:click="logout" class="btn black">Logout</button></li>
                <li class="divider"></li>
            </mobile-menu>
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss"></style>
<script>
    import firebase from "firebase"
    import store from "../../store/store"
    import TopNavbar from "./TopNavbar.vue"
    import ContentFooter from "./ContentFooter.vue"
    import DashboardContent from "./Content.vue"
    import MobileMenu from "./MobileMenu"
    export default {
        components: {
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu
        },
        data() {
            return {
                allowedForDashboard: false,
                isLoggedIn: false,
                // uhl: false,
                fahrer: false,
                büro: false,
                temp: false,
                kh: false,
                qs: false,
                ekki: false,
                uhlmail: "t.uhl@rewe-uhl.de",
                fahrermails: ["fahrer1@heimspiel.de", "fahrer2@heimspiel.de"],
                tempmails: ["temp1@heimspiel.de", "temp2@heimspiel.de"],
                qsmails: ["servicebereich@rewe-uhl.de"],
                büromail: "buero@heimspiel.de",
                khmail: "b.klinkhammer@rewe-uhl.de",
                ekkimail: "ea-gashi@hotmail.com"
            }
        },
        computed: {
            routeName() {
                const { name } = this.$route
                return this.capitalizeFirstLetter(name)
            }
        },
        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1)
            },
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            },
            logout: function () {
                firebase
                    .auth()
                    .signOut()
                    .then(() => {
                        store.state = false
                        this.$router.go({ path: this.$router.path })
                    })
            }
        },
        created: function () {
            //prüfen ob für dashboard zugriff gegeben werden soll

            if (firebase.auth().currentUser) {
                this.isLoggedIn = true
                var mail = firebase.auth().currentUser.email
                if (mail === this.uhlmail) {
                    this.allowedForDashboard = true
                    store.state = true
                    this.$router.push({ path: "/umsätze" })
                } else if (mail === this.büromail) {
                    this.büro = true
                } else if (mail === this.fahrermails[0] || mail === this.fahrermails[1]) {
                    this.fahrer = true
                } else if (mail === this.tempmails[0] || mail === this.tempmails[1]) {
                    this.temp = true
                    this.$router.push({ path: "/qs" })
                } else if (mail === this.qsmails[0]) {
                    this.qs = true
                    this.$router.push({ path: "/qs" })
                } else if (mail === this.khmail) {
                    this.kh = true
                    this.$router.push({ path: "/qs" })
                } else if (mail === this.ekkimail) {
                    this.ekki = true
                    this.$router.push({ path: "/qs" })
                }
            }
        }
    }
</script>
<style scoped>
    .sidebar-trenner {
        width: 100%;
    }
    .content {
        padding-top: 0px !important;
    }
    @media only screen and (max-width: 990px) {
        #logotrenner {
            padding-left: 0px;
            margin-left: 5px;
        }
    }
</style>
